import React from 'react';
import { MenuProps, components } from 'react-select';

import BottomSheet, { BottomSheetProps } from '@components/BottomSheet';
import { Option } from '@components/FormInput/types';

export type SearchableBottomSheetProps = Omit<
  BottomSheetProps,
  'isOpen' | 'children'
>;
export interface ExtendedCustomMenuProps {
  isBottomSheetMenu?: boolean;
  bottomSheetProps?: SearchableBottomSheetProps;
}
type CustomMenuProps = MenuProps<Option> & ExtendedCustomMenuProps;

const CustomMenu = (props: CustomMenuProps) => {
  const { isBottomSheetMenu, bottomSheetProps, ...defaultMenuProps } = props;
  return isBottomSheetMenu ? (
    <BottomSheet isOpen {...bottomSheetProps}>
      <components.Menu {...defaultMenuProps}>{props.children}</components.Menu>
    </BottomSheet>
  ) : (
    <components.Menu {...defaultMenuProps}>{props.children}</components.Menu>
  );
};

export const withExtendedCustomMenuPropsHOC = ({
  isBottomSheetMenu,
  bottomSheetProps,
}: ExtendedCustomMenuProps) => {
  return (props: MenuProps<Option>) => (
    <CustomMenu
      {...props}
      isBottomSheetMenu={isBottomSheetMenu}
      bottomSheetProps={bottomSheetProps}
    />
  );
};

export default CustomMenu;
